export default __webpack_public_path__ + "static/media/3B069A_2_0.9a4a858b.woff2";